// import { createBrowserHistory } from 'history';
// export default createBrowserHistory();
// src/utils/history.ts
const navigate = (path: string) => {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
};

export default navigate;
